import axiosClient from 'api/config/axiosClient';
import { isNull } from 'lodash';

export const getPartnersFileDownloadRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  filterId,
}) => {
  const url = `v1/logging/file-download-ranking/file-download/partners?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&filterId=${isNull(filterId) ? '' : filterId}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getAccountsFileDownloadRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  filterId,
}) => {
  const url = `v1/logging/file-download-ranking/file-download/accounts?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&filterId=${isNull(filterId) ? '' : filterId}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getFilesDownloadRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  filterId,
}) => {
  const url = `v1/logging/file-download-ranking/file-download/files?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&filterId=${isNull(filterId) ? '' : filterId}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getProducts = ({ keyword }) => {
  const url = `v1/product/logs${keyword ? `?keyword=${keyword}` : ''}`;
  return axiosClient.get(url, { timeout: 0 });
};
